export default __webpack_public_path__ + "static/media/cli-alph-resi_arvores.d3b1bacd.jpg";